// This multiplies a number by the exponent of the amount of decimals such as
// 1.00155e3 (1.00155 * 10^3 = 1001.55) then rounds it (1002), and then string concats it
// to the negative exponent 1002e-3 (1002 * 10^-3 = 1.002) to reduce it to the required decimal.
// It needs to use this somewhat clunky string conversion to avoid doing any arithmetic.
const roundNumber = (value, decimals)=>{
    return Number(`${Math.round(parseFloat(`${value}e${decimals}`))}` + `e-${decimals}`);
};

export { roundNumber };
//# sourceMappingURL=round-number.js.map
